import { clsx } from 'clsx';

export const getGridStyles = (hasTimezoneWarning: boolean) => {
  const baseClass = 'grid grid-cols-[repeat(2,min-content)_auto] items-center gap-3 text-body-m text-neutral-140';

  return clsx(baseClass, hasTimezoneWarning ? 'grid-rows-[min-content_repeat(2,auto)]' : 'grid-rows-[min-content]');
};
